
import { translations } from './lib/english/english.translations';
import { hebrewTranslations } from './lib/hebrew/hebrew.translations';
import { portugueseTranslations } from './lib/portuguese/portuguese.translations';

export const supportedLocales = [
    'en-US',
    'he',
    'pt-BR'
] as const;

export const localeTranslationMap = new Map<typeof supportedLocales[number], any>([
    ['en-US', translations],
    ['he', hebrewTranslations],
    ['pt-BR', portugueseTranslations]
]);